<template>
  <!-- <v-app-bar absolute color="#ffffff"> -->
  <v-row align="stretch" justify="space-between">

    <v-img
        :src="require('../../assets/st-pro-logo.svg')"
        class="ml-5"
        max-width="170px"
        contain
      />

    <v-row v-if="currentPlan" class="justify-end align-center ma-0">
      <nav>
        <ul class="nav-list font-weight-medium">
          <li @click="sendNavigationEvent('products')" class="nav-item" :class="{'active': this.active == 'PRODUCTS'}">
            <router-link to="/products">
              {{$t('navigation_products')}}
            </router-link>
          </li>
          <li @click="sendNavigationEvent('gallery')" v-if="totalCodesCount" class="nav-item" :class="{'active': this.active == 'GALLERY'}">
            <router-link to="/gallery">
              {{$t('navigation_gallery')}}
            </router-link>
          </li>
          <li @click="sendNavigationEvent('dashboard')" class="nav-item" :class="{'active': this.active == 'DASHBOARD'}">
            <router-link to="/">
              {{$t('navigation_dashboard')}}
            </router-link>
          </li>
          <li @click="sendNavigationEvent('upgrade')" class="nav-item" :class="{'active': this.active == 'UPGRADE'}">
            <router-link to="/upgrade?source=menu">
              {{$t('navigation_plans')}}
            </router-link>
          </li>
        </ul>
      </nav>
      <profile-navigation-btn></profile-navigation-btn>
    </v-row>

  </v-row>
</template>

<script>

import { mapGetters } from 'vuex'
import amplitude from 'amplitude-js'
import ProfileNavigationBtn from '@/components/profile/ProfileNavigationBtn'

export default {
  name: 'NavigationDesktop',
  props: ['active'],
  components: {
    ProfileNavigationBtn
  },
  computed: {
    ...mapGetters(['currentPlan', 'profile', 'totalCodesCount'])
  },
  methods: {
    sendNavigationEvent (tabName) {
      amplitude.getInstance().logEvent(`${tabName} open`)
      parent.postMessage({ type: 'navigation', data: tabName }, '*')
    }
  }
}

</script>

<style lang="sass" scoped>

@import "@/variables.sass"

.nav-list
  list-style: none
  margin: 0
  padding: 0
  .nav-item
    line-height: 57px
    margin: 0px 16px
    display: inline-block
    position: relative
    a
      text-decoration: none
      color: $black
    .nav-indicator
      bottom: 0
      position: absolute
      height: 6px
      background: white
    &.active
      border-bottom: 6px solid $primary
      a
        color: $primary

</style>
